import { render, staticRenderFns } from "./company-item.vue?vue&type=template&id=249aa037&scoped=true"
import script from "./company-item.vue?vue&type=script&lang=js"
export * from "./company-item.vue?vue&type=script&lang=js"
import style0 from "./company-item.vue?vue&type=style&index=0&id=249aa037&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249aa037",
  null
  
)

export default component.exports